import React from 'react';
import PaginationCenter from '../common/PaginationCenter';
import ProductCard from './ProductCard';

const Shop4 = () => {
    const ShopData = [
        {
            id: '1',
            img: 'images/products/10.jpg',
            name: 'Cocoa Brownies',
            price: '$65.00'
        },
        {
            id: '2',
            img: 'images/products/11.jpg',
            name: 'Choco Marshmallow',
            price: '$25.00'
        },
        {
            id: '3',
            img: 'images/products/12.jpg',
            name: 'Cream Cookie',
            price: '$15.00'
        },
        {
            id: '4',
            img: 'images/products/13.jpg',
            name: 'Choco Brownies',
            price: '$125.00'
        },
        {
            id: '5',
            img: 'images/products/14.jpg',
            name: 'Black Forest Cake',
            price: '$45.00'
        },
        {
            id: '6',
            img: 'images/products/15.jpg',
            name: 'Cheese Cake',
            price: '$75.00'
        },
        {
            id: '7',
            img: 'images/products/16.jpg',
            name: 'Choco Filled Puff',
            price: '$65.00'
        },
        {
            id: '8',
            img: 'images/products/17.jpg',
            name: 'Carrot & Nut Puff',
            price: '$115.00'
        },
        {
            id: '9',
            img: 'images/products/18.jpg',
            name: 'Dark Chocolate',
            price: '$30.00'
        },
        {
            id: '10',
            img: 'images/products/19.jpg',
            name: 'Flower Cookies',
            price: '$95.00'
        },
        {
            id: '11',
            img: 'images/products/20.jpg',
            name: 'Chocolate Cupcake',
            price: '$32.00'
        },
        {
            id: '12',
            img: 'images/products/21.jpg',
            name: 'Patty Chocolate',
            price: '$58.00'
        },
    ];

    return (
        <div className="main-wrapper">
            <div className="container">
                <div className="shopping dark_shop">
                    <div className="product_view_grid four_col">
                        <div className="row">
                            {
                                ShopData.map(data => <ProductCard
                                    key={data.id}
                                    data={data}
                                />)
                            }

                        </div>
                    </div>

                    <PaginationCenter />
                </div>
            </div>
        </div>
    );
};

export default Shop4;